import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)
const attributes = {
  hoverChip: {
    closeDelay: 35,
    openDelay: 35,
    doesHover: true
  },
  pulse: {
    pulseInterval: 5000
  },
  experience: {
    fluid: false,
    galleryItemWidth: 4
  }
}
export default new Vuex.Store({
  state: {
    navigation: "sidebar",
    versioning: {
      date: process.env.VUE_APP_BUILD_DATE,
      version: process.env.VUE_APP_VERSION
    },
    lastRoute: "/",
    pulse: {
      timeSpentFocused: 0,
      timeSpentLastRoute: 0
    },
    quickSwitchCache: [
      { name: "Home", route: "/" },
      { name: "Gallery", route: "/gallery" },
      { name: "Settings", route: "/settings" },
      { name: "Collections", route: "/collections" }
    ],
    attributes: {
      ...attributes
    },
    defaultAttributes: {
      ...attributes
    },
    site: {
      stats: {
        users: 0,
        domains: 0,
        usage: {
          result: 0
        },
        uploads: 0
      },
      openRegistrations: false,
      debug: [],
      loading: true,
      maintenance: false,
      matomoId: 2,
      name: "TPU",
      hostname: "images.flowinity.com",
      hostnameWithProtocol: "https://images.flowinity.com",
      whitelabel: true
    },
    errorHandler: {
      errors: [],
      enabled: false
    },
    user: {
      id: 0,
      username: "",
      token: "",
      admin: false,
      darkTheme: true,
      description: "",
      apiKey: "",
      banned: false,
      totalNotifications: 0,
      totalUploads: 0,
      createdAt: "2021-07-30T12:56:09.000Z",
      notifications: [],
      inviteEntitlements: 0,
      flowinityId: null,
      domainId: 1,
      pendingAutoCollects: 0,
      domain: {
        domain: "i.troplo.com"
      },
      invite: null,
      inviteId: 0,
      beta: false,
      premium: false,
      avatar: null,
      openGraphColor: "#ffffff",
      discordId: "",
      discordUserCache: "",
      subdomain: null,
      totpEnable: false,
      openGraph: true,
      customPath: "/",
      quota: 0,
      plan: {
        id: 1,
        name: "Free",
        price: 0,
        features:
          '["768MB of Storage", "25MB File Size Limit", "1 invites per wave"]',
        color: null,
        internalName: "FREE",
        purchasable: true,
        icon: "mdi-plus",
        createdAt: "2021-08-30T15:39:23.000Z",
        updatedAt: "2021-08-30T15:39:23.000Z",
        quotaMax: 0
      },
      moderator: false,
      credits: 0,
      subscription: {
        cancelled: false,
        expiredAt: null,
        createdAt: null,
        updatedAt: null,
        cancelledAt: null
      },
      fakePath: false,
      fakePathValue: ""
    },
    experiments: {},
    experimentsInherit: {}
  },
  mutations: {
    setExperiments(state, payload) {
      state.experiments = payload
    },
    login(state, data) {
      state.user.token = data.token
      state.user.username = data.username
      state.user.description = data.description
      state.user.apiKey = data.apiKey
      state.user.banned = data.banned
      state.user.admin = data.administrator
      state.user.totalNotifications = data.totalNotifications
      state.user.totalUploads = data.totalUploads
      state.user.createdAt = data.createdAt
      state.user.inviteEntitlements = data.inviteEntitlements
      state.user.domainId = data.domainId
      state.user.domain = data.domain
      state.user.invite = data.invite
      state.user.inviteId = data.inviteId
      state.user.id = data.id
      state.user.premium = data.premium
      state.user.beta = data.beta
      state.user.avatar = data.avatar
      state.user.openGraphColor = data.openGraphColor
      state.user.discordId = data.discordId
      state.user.subdomain = data.subdomain
      state.user.totpEnable = data.totpEnable
      state.user.quota = data.quota
      state.user.plan = data.plan
      state.user.moderator = data.moderator
      state.user.credits = data.credits
      state.user.flowinityId = data.flowinityId
      state.user.openGraph = data.openGraph
      state.user.customPath = data.customPath
      state.user.fakePath = data.fakePath
      state.user.fakePathValue = data.fakePathValue
      state.user.pendingAutoCollects = data.pendingAutoCollects
      state.user.invitesV2Visible = data.invitesV2Visible
      state.user.email = data.email
    },
    setSubscription(state, data) {
      state.user.subscription = data.subscription
    },
    setDiscordCache(state, data) {
      state.user.discordUserCache = data
    },
    devLogin(state, data) {
      state.user.username = data
      state.user.token = data
    },
    updateToken(state, data) {
      state.user.token = data
    },
    setTheme(state, data) {
      state.user.darkTheme = data
    },
    setRoute(state, data) {
      state.site.route = data
    },
    devNotification(state, data) {
      state.site.devNotification = data
    },
    setAjaxErrors(state, data) {
      state.errorHandler.errors = data
    },
    enableAjaxErrors(state, data) {
      state.errorHandler.enabled = data
    },
    state(state, data) {
      state.site = data
    },
    setWhitelabel(state, data) {
      state.site.whitelabel = data
    },
    stateStats(state, data) {
      state.site.stats = data
    },
    updateNavigation(state, data) {
      state.navigation = data
    }
  },
  actions: {
    setupExperiments(context) {
      Vue.axios.get("/api/v1/site/experiments").then((res) => {
        context.state.experimentsInherit = res.data
        context.commit("setExperiments", {
          ...res.data,
          ...JSON.parse(localStorage.getItem("experiments") || "{}")
        })
      })
    },
    quickSwitchCache(context) {
      Vue.axios.get("/api/v1/collections").then((res) => {
        context.state.quickSwitchCache = [
          { name: "Home", route: "/" },
          { name: "Gallery", route: "/gallery" },
          { name: "Settings", route: "/settings" },
          { name: "Collections", route: "/collections" },
          { name: "AutoCollect", route: "/autoCollect" }
        ]
        for (const collection of res.data.rows) {
          context.state.quickSwitchCache.push({
            name: collection.name,
            id: collection.id,
            route: "/collections/" + collection.id
          })
        }
      })
    }
  },
  modules: {}
})
